<template>
  <div class="home">
    <div id="nav">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
      <Header />

      <Menu />

      <div class="container">

        <Gallery />

      </div>

      <Footer />

    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
}

</script>
